import { Copy } from 'lucide-react';

import { Button } from '@app/shared/ui/atoms/Common';

interface CopyLabelProps {
  label: string;
  onCopy: () => void;
}

export function CopyLabel({ label, onCopy }: CopyLabelProps) {
  return (
    <div className="flex items-center gap-1.5 overflow-hidden">
      <Button variant="custom" className="h-auto p-0.5" onClick={onCopy}>
        <Copy size={18} className="text-accent" />
      </Button>
      <b className="truncate">{label}</b>
    </div>
  );
}
